import styled from 'styled-components';

export const CustomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  box-shadow: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
`;
